import type { TAiChatToolName } from '../interfaces/IAiChatTools';

/**
 * Translation key of each tool's label, the name the reader sees in place of the one the model
 * calls. Every tool the FE knows has one — the type demands it — so this map is also the list of
 * the tools the FE knows.
 *
 * A new tool needs an entry here and in `aiChat.tools` in `src/i18n/en/aiChat.ts`.
 * @see [12.2 Show the tool on the frontend](../../../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 */
const TOOL_LABEL_KEYS: Record<TAiChatToolName, string> = {
  writeDocument: 'aiChat.tools.writeDocument',
  lookUpDocument: 'aiChat.tools.lookUpDocument',
  shareDocument: 'aiChat.tools.shareDocument',
  listValueChains: 'aiChat.tools.listValueChains',
  lookupStandards: 'aiChat.tools.lookupStandards',
  lookupPublicCompany: 'aiChat.tools.lookupPublicCompany',
  lookupDossierPublicFacts: 'aiChat.tools.lookupDossierPublicFacts',
  searchWatchCompanies: 'aiChat.tools.searchWatchCompanies',
  createWatchCompanies: 'aiChat.tools.createWatchCompanies',
  fetchData: 'aiChat.tools.fetchData',
  createDatasource: 'aiChat.tools.createDatasource',
  showDatasource: 'aiChat.tools.showDatasource',
  showChart: 'aiChat.tools.showChart',
  createImpactAnalysis: 'aiChat.tools.createImpactAnalysis',
  updateImpactAnalysis: 'aiChat.tools.updateImpactAnalysis',
  startImpactAnalysis: 'aiChat.tools.startImpactAnalysis',
  createAgentSession: 'aiChat.tools.createAgentSession',
  updateAgentSessionUnits: 'aiChat.tools.updateAgentSessionUnits',
  startAgentSearch: 'aiChat.tools.startAgentSearch',
  createMonitoringSession: 'aiChat.tools.createMonitoringSession',
  updateMonitoringSessionUnits: 'aiChat.tools.updateMonitoringSessionUnits',
  startMonitoringSession: 'aiChat.tools.startMonitoringSession',
};

export default TOOL_LABEL_KEYS;
